import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import * as React from 'react';
import { DeltaXMLColors } from '../material-ui/styling/DeltaColors';
import { AuthContext } from './AuthContext';

export interface HandleAuthProps {
    errorMessage: string;
    errorCode: string;
}

export default function HandleAuth(props: HandleAuthProps) {
    const {errorMessage, errorCode} = props;
    const [open, setOpen] = React.useState(true);
    const auth = React.useContext(AuthContext);

    const handleClose = () => {  
    setOpen(false);
    auth.login();
    }

    return(
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{errorCode}</DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {errorMessage} <br/>
                    Please login again and if the problem still continues, <a style={{color: DeltaXMLColors.FOUNTAIN_BLUE}} href="https://www.deltaxml.com/contact/">contact DeltaXML support</a>
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={handleClose} color="primary" variant="contained" autoFocus>
                    Close
                </Button>
                </DialogActions>
            </Dialog>
        </div>
    )   
  }